import {
  SET_PICKUP_PERSON_FORM_FIELD,
  SET_PICKUP_PERSON_FORM,
  RESET_PICKUP_PERSON_FORM
} from 'actions/account/pickupPeople/actionTypes'

const form = (state = {}, action) => {
  switch (action.type) {
    case SET_PICKUP_PERSON_FORM_FIELD:
      return Object.assign({}, state, { [action.field]: action.value })
    case SET_PICKUP_PERSON_FORM:
      return action.data
    case RESET_PICKUP_PERSON_FORM:
      return null
    default:
      return state
  }
}

export default form
